query SupportRequestsList(
  $page: Int
  $rowsPerPage: Int
  $filter: SupportRequestsFilterInput
) {
  supportRequests(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      number
      subject
      type
      status
      createdAt
      lastMessageAt
      user {
        id
        email
        displayName
      }
      platform {
        id
        title
      }
      organization {
        id
        title
      }
    }
  }
}
